<template>
  <div id="login">
    <div class="main-container" style="background: var(--default)">
      <!-- Header -->
      <div class="header bg-gradient-primary py-7 py-lg-8">
        <div class="container">
          <div class="header-body text-center mb-7">
            <div class="row justify-content-center">
              <div class="col-lg-5 col-md-6">
                <h1 class="text-white">{{ $i18n.t('login.title') }}</h1>
                <p class="text-lead text-light">{{ $i18n.t('login.subtitle') }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="separator separator-bottom separator-skew zindex-100">
          <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
          </svg>
        </div>
      </div>
      <!-- Page content -->
      <div class="container mt--8 pb-5">
        <div class="row justify-content-center">
          <div class="col-lg-5 col-md-7">
            <div class="card bg-secondary shadow border-0">
              <!-- <div class="card-header bg-transparent pb-5">
                <div class="text-muted text-center mt-2 mb-3"><small>Se connecter avec</small></div>
                <div class="btn-wrapper text-center">
                    <a href="#" class="btn btn-neutral btn-icon">
                      <span class="btn-inner--text">Facebook</span>
                    </a>
                  </div>
              </div> -->
              <div class="card-body px-lg-5 py-lg-5">
                <div class="text-center text-muted mb-4">
                  <small>{{ $i18n.t('login.credentials.title') }}</small>
                </div>
                <div class="alert alert-warning" role="alert" v-if="error">
                  <span class="alert-inner--text"><strong>Warning!</strong> {{ error }}</span>
                </div>
                <form role="form" @submit.prevent="login">
                  <div class="form-group mb-3">
                    <div class="input-group input-group-alternative">
                      <div class="input-group-prepend">
                        <span class="input-group-text"><i class="ni ni-email-83"></i></span>
                      </div>
                      <input class="form-control" :placeholder="$i18n.t('login.email')" type="email" v-model="email">
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="input-group input-group-alternative">
                      <div class="input-group-prepend">
                        <span class="input-group-text"><i class="ni ni-lock-circle-open"></i></span>
                      </div>
                      <input class="form-control" :placeholder="$i18n.t('login.password')" type="password" v-model="password">
                    </div>
                  </div>
                  <div class="text-center">
                    <button type="submit" class="btn btn-primary my-4" :disable="loading">
                      <span v-if="loading"><img src="../../static/img/loading.gif" alt="Loading" width="10"></span>
                      <span v-else>{{ $i18n.t('login.credentials.signin') }}</span>
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div class="row mt-3">
              <!-- <div class="col-6">
                <a href="#" class="text-light"><small>{{ $i18n.t('login.forgotten_password') }}</small></a>
              </div> -->
              <div class="col-12 text-center">
                <a href="#" @click.prevent="$router.replace({ name: 'register' })" class="text-light"><small>{{ $i18n.t('login.new_account') }}</small></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      email: '',
      password: '',
      error: '',
      loading: false
    }
  },
  mounted () {
    // this.$store.dispatch('fetchUser')
    this.$store.dispatch('checkUserStatus')
  },
  computed: {
    isLogged () {
      let user = this.$store.getters.user || localStorage.getItem('user')
      if (user) {
        this.$emit('authenticated', true)
        this.$router.replace({ name: 'home' })
      }
      return user
    },
    haveError () {
      return this.$store.getters.error
    }
  },
  watch: {
    haveError (value) {
      this.loading = false
      this.error = value
    },
    isLogged (value) {
      // console.log('LOGIN isLogged', value)
    }
  },
  methods: {
    login () {
      this.loading = true
      this.$store.dispatch('userLogin', {email: this.email, password: this.password})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue